export const DEFAULT_BRAND_KEY = 'DEFAULT'

//Ảnh rỗng/null từ BE KHÔNG được tính là nội dung. Nếu tính thì entry chỉ có ảnh rỗng sẽ pass
//hasContent rồi render ra khối trắng (đúng lỗi mà hasContent sinh ra để chặn), và icon con mắt
//của ảnh đó click vào không mở được Modal -> click "chết" im lặng mà vẫn lấy focus khỏi ô quét.
const safeImages = (item = {}) => {
    const { images } = { ...item }

    return Array.isArray(images) ? images.filter(i => typeof i === 'string' && !!i.trim()) : []
}

//Entry chỉ được hiển thị khi có nội dung, tránh entry rỗng tạo ra khối trắng trên UI
//Description toàn khoảng trắng cũng KHÔNG phải nội dung — đối xứng với safeImages.
//Nếu không trim: entry brand có description '   ' vẫn thắng hasContent nên CHẶN fallback sang DEFAULT
//(brandDescription.js dòng dưới: hasContent(byBrand) ? byBrand : byDefault) -> mô tả DEFAULT hợp lệ
//bị ẩn hoàn toàn, QC viên chỉ thấy một ô xám trống.
const safeText = (value) => typeof value === 'string' ? value.trim() : ''

const hasContent = (item = {}) => !!safeText(item.description) || !!safeImages(item).length

const normalize = (item = {}) => {
    const { brand = '' } = { ...item }

    return {
        ...item,
        brand: brand || '',
        description: safeText(item.description),
        images: safeImages(item),
    }
}

/**
 * Danh sách khối mô tả QCHT cần hiển thị cho 1 item, lấy từ brands_description_packaged.
 * Ưu tiên mô tả ứng với brand của item; brand đó không có mô tả thì mới fallback sang DEFAULT.
 * Chỉ hiển thị MỘT mô tả tại một thời điểm -> mảng trả về tối đa 1 phần tử.
 *
 * Cùng CHIỀU ưu tiên với getPackingInfo trong MarkPackagedPageSpecifications
 * (bên đó: brand -> shipping-carrier -> default): cụ thể trước, dùng chung sau.
 * Feature này chỉ có 2 bậc (brand -> DEFAULT) vì brands_description_packaged
 * chỉ phân biệt theo brand, không có bậc nào theo hãng vận chuyển.
 *
 * Vẫn trả về ARRAY (không phải 1 object) để tầng render map qua danh sách — quy tắc kết hợp
 * brand/DEFAULT đã đổi nhiều lần nên giữ policy tập trung ở đây, đổi quy tắc chỉ sửa file này.
 */
export const resolveBrandDescriptions = (list = [], brandName = '') => {
    const safeList = Array.isArray(list) ? list : []
    const byBrand = (!!brandName && safeList.find(i => !!i && i.brand === brandName)) || {}
    const byDefault = safeList.find(i => !!i && i.brand === DEFAULT_BRAND_KEY) || {}

    //hasContent chứ không phải "tồn tại entry": brand có entry nhưng rỗng thì vẫn fallback DEFAULT
    return [hasContent(byBrand) ? byBrand : byDefault].filter(hasContent).map(normalize)
}
